import { ButtonHTMLAttributes, forwardRef } from 'react'

import SVGIcon from '@/components/base/svg-icon'

import { cn } from '@/lib/utils'

export type CloseButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  label?: string
}

const CloseButton = forwardRef<HTMLButtonElement, CloseButtonProps>(
  ({ label = 'Chiudi', className, ...props }, ref) => {
    return (
      <button
        type="button"
        aria-label={label}
        className={cn(
          'absolute right-[19px] top-[19px] z-30 flex size-[60px] items-center justify-center rounded-full border border-border-secondary-dark/20 bg-[black]/20 text-[white] backdrop-blur-[17px]',
          className
        )}
        {...props}
        ref={ref}
      >
        <SVGIcon symbol="close" className="size-[16px]" />
      </button>
    )
  }
)

CloseButton.displayName = 'CloseButton'

export default CloseButton
